export const FETCH_TRANSFERS_PENDING = "FETCH_TRANSFERS_PENDING";
export const FETCH_TRANSFERS_REJECTED = "FETCH_TRANSFERS_REJECTED";
export const FETCH_TRANSFERS_FULFILLED = "FETCH_TRANSFERS_FULFILLED";



// WEBPACK FOOTER //
// ./src/constants/transfers.js